import React from "react";
import "./trafficLightIndicator.css";

const TrafficLightIndicatorWork = ({ category, riskLevel, recommendation }) => {
  let textRisk = ""
  // Asignar color según el nivel de riesgo
  const getColor = (level) => {
    switch (level) {
      case 0:
        textRisk = "Satisfacción alta"
        return "green";
      case 1:
        textRisk = "Inconformidad moderada"
        return "yellow";
      case 2:
        textRisk = "Insatisfacción alta"
        return "red";
      default:
        return "gray";
    }
  };

  return (
    <div className="traffic-light-indicator">
      <h3 className="category-title">&nbsp;</h3>
      <div className={`traffic-light ${getColor(riskLevel)}`}>
        {textRisk}
      </div>
      <p className="recommendation">{recommendation}</p>
    </div>
  );
};

export default TrafficLightIndicatorWork;
